/**
 * Sub-Customers Selectors
 */

import { createSelector } from '@spcc/core'
import { initialSubCustomersState, type SubCustomersState } from './sub-customers.slice'

interface RootState {
  subCustomers?: SubCustomersState
}

const selectState = (state: RootState) => state.subCustomers ?? initialSubCustomersState

export const selectSubCustomers = createSelector(selectState, (s) => s.items)
export const selectSubCustomersLoading = createSelector(selectState, (s) => s.loading)
export const selectSubCustomersError = createSelector(selectState, (s) => s.error)
export const selectSubCustomersFilter = createSelector(selectState, (s) => s.filter)
export const selectSubCustomersPagination = createSelector(selectState, (s) => s.pagination)
export const selectSubCustomerForm = createSelector(selectState, (s) => s.form)
/** True when something narrows the list (the empty state then hides "Add"). */
export const selectSubCustomersIsFiltered = createSelector(selectSubCustomersFilter, (f) => Boolean(f.search?.trim() || f.customerType))
